import { jsx, jsxs } from 'react/jsx-runtime';
import 'react';
import { css, Global, ThemeProvider } from '@emotion/react';

const fontsPath = "https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/GLOBAL/";
const fontFaces = css `
    /*
	=============================================
	NVIDIA Sans fonts
    Owner: Vadim Leontjev (vleontjev@nvidia.com)
	=============================================
    */

    /* Set up for old browsers*/
    @supports not (font-variation-settings: normal) {
        /* GLOABL */
        @font-face {
            font-family: "NVIDIA";
            src:
                url("${fontsPath}NVIDIASans_W_Lt.woff") format("woff"),
                url("${fontsPath}NVIDIASans_W_Lt.woff2") format("woff2");
            font-weight: 300;
            font-style: normal;
        }
        @font-face {
            font-family: "NVIDIA";
            src:
                url("${fontsPath}NVIDIASans_W_Rg.woff") format("woff"),
                url("${fontsPath}NVIDIASans_W_Rg.woff2") format("woff2");
            font-weight: 400;
            font-style: normal;
        }
        @font-face {
            font-family: "NVIDIA";
            src:
                url("${fontsPath}NVIDIASans_W_Md.woff") format("woff"),
                url("${fontsPath}NVIDIASans_W_Md.woff2") format("woff2");
            font-weight: 500;
            font-style: normal;
        }
        @font-face {
            font-family: "NVIDIA";
            src:
                url("${fontsPath}NVIDIASans_W_Bd.woff") format("woff"),
                url("${fontsPath}NVIDIASans_W_Bd.woff2") format("woff2");
            font-weight: 700;
            font-style: normal;
        }
        /* NALA */
        @font-face {
            font-family: "NVIDIA-NALA";
            src:
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/NALA/NVIDIASans_NALA_W_Lt.woff")
                    format("woff"),
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/NALA/NVIDIASans_NALA_W_Lt.woff2")
                    format("woff2");
            font-weight: 300;
            font-style: normal;
        }
        @font-face {
            font-family: "NVIDIA-NALA";
            src:
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/NALA/NVIDIASans_NALA_W_Rg.woff")
                    format("woff"),
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/NALA/NVIDIASans_NALA_W_Rg.woff2")
                    format("woff2");
            font-weight: 400;
            font-style: normal;
        }
        @font-face {
            font-family: "NVIDIA-NALA";
            src:
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/NALA/NVIDIASans_NALA_W_Md.woff")
                    format("woff"),
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/NALA/NVIDIASans_NALA_W_Md.woff2")
                    format("woff2");
            font-weight: 500;
            font-style: normal;
        }
        @font-face {
            font-family: "NVIDIA-NALA";
            src:
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/NALA/NVIDIASans_NALA_W_Bd.woff")
                    format("woff"),
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/NALA/NVIDIASans_NALA_W_Bd.woff2")
                    format("woff2");
            font-weight: 700;
            font-style: normal;
        }
        /* EMEA */
        @font-face {
            font-family: "NVIDIA-EMEA";
            src:
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/EMEA/NVIDIASans_EMEA_W_Lt.woff")
                    format("woff"),
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/EMEA/NVIDIASans_EMEA_W_Lt.woff2")
                    format("woff2");
            font-weight: 300;
            font-style: normal;
        }
        @font-face {
            font-family: "NVIDIA-EMEA";
            src:
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/EMEA/NVIDIASans_EMEA_W_Rg.woff")
                    format("woff"),
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/EMEA/NVIDIASans_EMEA_W_Rg.woff2")
                    format("woff2");
            font-weight: 400;
            font-style: normal;
        }
        @font-face {
            font-family: "NVIDIA-EMEA";
            src:
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/EMEA/NVIDIASans_EMEA_W_Md.woff")
                    format("woff"),
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/EMEA/NVIDIASans_EMEA_W_Md.woff2")
                    format("woff2");
            font-weight: 500;
            font-style: normal;
        }
        @font-face {
            font-family: "NVIDIA-EMEA";
            src:
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/EMEA/NVIDIASans_EMEA_W_Bd.woff")
                    format("woff"),
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/EMEA/NVIDIASans_EMEA_W_Bd.woff2")
                    format("woff2");
            font-weight: 700;
            font-style: normal;
        }
        /* RU */
        @font-face {
            font-family: "NVIDIA-RU";
            src:
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/RU/NVIDIASans_CYR_W_Lt.woff")
                    format("woff"),
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/RU/NVIDIASans_CYR_W_Lt.woff2")
                    format("woff2");
            font-weight: 300;
            font-style: normal;
        }
        @font-face {
            font-family: "NVIDIA-RU";
            src:
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/RU/NVIDIASans_CYR_W_Rg.woff")
                    format("woff"),
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/RU/NVIDIASans_CYR_W_Rg.woff2")
                    format("woff2");
            font-weight: 400;
            font-style: normal;
        }
        @font-face {
            font-family: "NVIDIA-RU";
            src:
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/RU/NVIDIASans_CYR_W_Md.woff")
                    format("woff"),
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/RU/NVIDIASans_CYR_W_Md.woff2")
                    format("woff2");
            font-weight: 500;
            font-style: normal;
        }
        @font-face {
            font-family: "NVIDIA-RU";
            src:
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/RU/NVIDIASans_CYR_W_Bd.woff")
                    format("woff"),
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/RU/NVIDIASans_CYR_W_Bd.woff2")
                    format("woff2");
            font-weight: 700;
            font-style: normal;
        }
        /* APAC */
        @font-face {
            font-family: "NVIDIA-APAC";
            src:
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Lt.woff")
                    format("woff"),
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Lt.woff2")
                    format("woff2");
            font-weight: 300;
            font-style: normal;
        }
        @font-face {
            font-family: "NVIDIA-APAC";
            src:
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Rg.woff")
                    format("woff"),
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Rg.woff2")
                    format("woff2");
            font-weight: 400;
            font-style: normal;
        }
        @font-face {
            font-family: "NVIDIA-APAC";
            src:
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Md.woff")
                    format("woff"),
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Md.woff2")
                    format("woff2");
            font-weight: 500;
            font-style: normal;
        }
        @font-face {
            font-family: "NVIDIA-APAC";
            src:
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Bd.woff")
                    format("woff"),
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Bd.woff2")
                    format("woff2");
            font-weight: 700;
            font-style: normal;
        }
        /* CN */
        @font-face {
            font-family: "NVIDIA-CN";
            src:
                url("https://images.nvidia.cn/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Lt.woff")
                    format("woff"),
                url("https://images.nvidia.cn/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Lt.woff2")
                    format("woff2");
            font-weight: 300;
            font-style: normal;
        }
        @font-face {
            font-family: "NVIDIA-CN";
            src:
                url("https://images.nvidia.cn/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Rg.woff")
                    format("woff"),
                url("https://images.nvidia.cn/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Rg.woff2")
                    format("woff2");
            font-weight: 400;
            font-style: normal;
        }
        @font-face {
            font-family: "NVIDIA-CN";
            src:
                url("https://images.nvidia.cn/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Md.woff")
                    format("woff"),
                url("https://images.nvidia.cn/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Md.woff2")
                    format("woff2");
            font-weight: 500;
            font-style: normal;
        }
        @font-face {
            font-family: "NVIDIA-CN";
            src:
                url("https://images.nvidia.cn/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Bd.woff")
                    format("woff"),
                url("https://images.nvidia.cn/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Bd.woff2")
                    format("woff2");
            font-weight: 700;
            font-style: normal;
        }
    }

    /* Set up for modern browsers, all weights */
    @supports (font-variation-settings: normal) {
        @font-face {
            font-family: "NVIDIA-NALA";
            src:
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/NALA/var/NVIDIASansVF_NALA_W_Wght.woff2")
                    format("woff2 supports variations"),
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/NALA/var/NVIDIASansVF_NALA_W_Wght.woff2")
                    format("woff2-variations");
            font-weight: 100 1000;
            font-stretch: 25% 151%;
            font-style: normal;
        }
        @font-face {
            font-family: "NVIDIA-NALA";
            src:
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/NALA/var/NVIDIASansVF_Wght_NALA_W_Italic.woff2")
                    format("woff2 supports variations"),
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/NALA/var/NVIDIASansVF_Wght_NALA_W_Italic.woff2")
                    format("woff2-variations");
            font-weight: 100 1000;
            font-stretch: 25% 151%;
            font-style: italic;
        }

        @font-face {
            font-family: "NVIDIA-EMEA";
            src:
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/EMEA/var/NVIDIASansVF_EMEA_W_Wght.woff2")
                    format("woff2 supports variations"),
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/EMEA/var/NVIDIASansVF_EMEA_W_Wght.woff2")
                    format("woff2-variations");
            font-weight: 100 1000;
            font-stretch: 25% 151%;
            font-style: normal;
        }

        @font-face {
            font-family: "NVIDIA-EMEA";
            src:
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/EMEA/var/NVIDIASansVF_Wght_EMEA_W_Italic.woff2")
                    format("woff2 supports variations"),
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/EMEA/var/NVIDIASansVF_Wght_EMEA_W_Italic.woff2")
                    format("woff2-variations");
            font-weight: 100 1000;
            font-stretch: 25% 151%;
            font-style: italic;
        }

        @font-face {
            font-family: "NVIDIA-RU";
            src:
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/RU/var/NVIDIASansVF_CYR_W_Wght.woff2")
                    format("woff2 supports variations"),
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/RU/var/NVIDIASansVF_CYR_W_Wght.woff2")
                    format("woff2-variations");
            font-weight: 100 1000;
            font-stretch: 25% 151%;
            font-style: normal;
        }
        @font-face {
            font-family: "NVIDIA-RU";
            src:
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/RU/var/NVIDIASansVF_Wght_CYR_W_Italic.woff2")
                    format("woff2 supports variations"),
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/RU/var/NVIDIASansVF_Wght_CYR_W_Italic.woff2")
                    format("woff2-variations");
            font-weight: 100 1000;
            font-stretch: 25% 151%;
            font-style: italic;
        }

        @font-face {
            font-family: "NVIDIA-APAC";
            src:
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/var/NVIDIASansVF_APAC_W_Wght.woff2")
                    format("woff2 supports variations"),
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/var/NVIDIASansVF_APAC_W_Wght.woff2")
                    format("woff2-variations");
            font-weight: 100 1000;
            font-stretch: 25% 151%;
            font-style: normal;
        }
        @font-face {
            font-family: "NVIDIA-APAC";
            src:
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/var/NVIDIASansVF_Wght_APAC_W_Italic.woff2")
                    format("woff2 supports variations"),
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/var/NVIDIASansVF_Wght_APAC_W_Italic.woff2")
                    format("woff2-variations");
            font-weight: 100 1000;
            font-stretch: 25% 151%;
            font-style: italic;
        }
        @font-face {
            font-family: "NVIDIA-CN";
            src:
                url("https://images.nvidia.cn/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/var/NVIDIASansVF_APAC_W_Wght.woff2")
                    format("woff2 supports variations"),
                url("https://images.nvidia.cn/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/var/NVIDIASansVF_APAC_W_Wght.woff2")
                    format("woff2-variations");
            font-weight: 100 1000;
            font-stretch: 25% 151%;
            font-style: normal;
        }
        @font-face {
            font-family: "NVIDIA-CN";
            src:
                url("https://images.nvidia.cn/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/var/NVIDIASansVF_Wght_APAC_W_Italic.woff2")
                    format("woff2 supports variations"),
                url("https://images.nvidia.cn/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/var/NVIDIASansVF_Wght_APAC_W_Italic.woff2")
                    format("woff2-variations");
            font-weight: 100 1000;
            font-stretch: 25% 151%;
            font-style: italic;
        }
        @font-face {
            font-family: "NVIDIA";
            src:
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/GLOBAL/var/NVIDIASansVF_W_Wght.woff2")
                    format("woff2 supports variations"),
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/GLOBAL/var/NVIDIASansVF_W_Wght.woff2")
                    format("woff2-variations");
            font-weight: 100 1000;
            font-stretch: 25% 151%;
            font-style: normal;
        }
        @font-face {
            font-family: "NVIDIA";
            src:
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/GLOBAL/var/NVIDIASansVF_Wght_W_Italic.woff2")
                    format("woff2 supports variations"),
                url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/GLOBAL/var/NVIDIASansVF_Wght_W_Italic.woff2")
                    format("woff2-variations");
            font-weight: 100 1000;
            font-stretch: 25% 151%;
            font-style: italic;
        }
    }
`;

const fallbackFonts = "Arial,Helvetica,Sans-Serif";
const isAEM = typeof NVIDIAGDC === "object";
const globalTheme = {
    palette: {
        primary: [
            "#76b900", // 0 primary
            "#96c720", // 1 lighter
            "#6AA700", // 2 darker
            "#DFF0D9", // 3 pale
            "#8dc200", // 4 button pressed
        ],
        error: [
            "#f08039", // orange
            "#f03232", // red
            "#f2dedf", // light red
            "#f44336", // dark red
        ],
        grey: [
            "#1a1a1a", // 0
            "#292929", // 1
            "#494949", // 2
            "#999", // 3
            "#ccc", // 4
            "#ebebeb", // 5
            "#545454", // 6
            "#707070", // 7
            "#f5f2f2", // 8
            "#bfbfbf", // 9
            "#f1f1f1", // 10
            "#666", // 11
            "#333", // 12
            "#F7F7F7", //13
            "#eee", //14
        ],
        white: ["#FFFFFF"],
        black: [
            "#000", // 0
            "#111", // 1
        ],
    },
    newPalette: {
        white: "#FFFFFF",
        "grey-50": "#F7F7F7",
        "grey-100": "#EEEEEE",
        "grey-200": "#DDDDDD",
        "grey-300": "#CCCCCC",
        "grey-400": "#999999",
        "grey-500": "#808080",
        "grey-600": "#666666",
        "grey-700": "#333333",
        "grey-800": "#222222",
        "grey-900": "#1A1A1A",
        "grey-950": "#111111",
        black: "#000000",
    },
    colors: {
        primary: "#76b900",
        black: "#000000",
        success: "#B2E639",
        info: "#66CFF2",
        warning: "#FFBC01",
        error: "#F28080",
        neutral: "#DDDDDD",
    },
    fontStacks: {
        // default: (IS_LOCAL_BUILD || realmConfig.isStandalone)
        //     ? `${defaultFont}${localeFont},${fallbackFont}`
        //     : null,   // web portal inherits fonts from AEM
        default: `NVIDIA,${fallbackFonts}`,
        monospace: 'monospace, "Courier New", Courier',
    },
    mediaQueries: {
        xs: `@media (min-width: 320px)`,
        sm: `@media (min-width: 640px)`,
        md: `@media (min-width: 768px)`,
        lg: `@media (min-width: 1024px)`,
        xl: `@media (min-width: 1280px)`,
        "2xl": `@media (min-width: 1350px)`,
    },
};
const globalStyles = css `
    ${fontFaces}

    *,
    *:before,
    *:after {
        box-sizing: border-box;
    }

    ${!isAEM
    ? `
        :lang(en-us),
        :lang(en-zz),
        :lang(en-gb),
        :lang(en-au),
        :lang(en-eu),
        :lang(en-in),
        :lang(en-il),
        :lang(es-la),
        :lang(es-uy),
        :lang(es-cl),
        :lang(es-py),
        :lang(es-ar),
        :lang(pt-br) * {
            font-family: NVIDIA-NALA, ${fallbackFonts};
        }
        :lang(de-at),
        :lang(fr-be),
        :lang(cs-cz),
        :lang(da-dk),
        :lang(nl-nl),
        :lang(nb-no),
        :lang(pl-pl),
        :lang(pt-pt),
        :lang(ro-ro),
        :lang(es-es),
        :lang(sv-se),
        :lang(de-ch),
        :lang(tr-tr),
        :lang(de-de),
        :lang(fr-fr),
        :lang(fi-fi),
        :lang(it-it),
        :lang(hu-hu),
        :lang(sl-si),
        :lang(sk-sk) * {
            font-family: NVIDIA-EMEA, ${fallbackFonts};
        }
        :lang(ru-ru) * {
            font-family: NVIDIA-RU, ${fallbackFonts};
        }
        :lang(ja-jp),
        :lang(ko-kr),
        :lang(zh-tw) * {
            font-family: NVIDIA-APAC, ${fallbackFonts};
        }
        :lang(zh-cn) * {
            font-family: NVIDIA-CN, ${fallbackFonts};
        }
        `
    : ""}

    .hide-overflow {
        overflow: hidden;
    }

    .m-0-t {
        margin-top: 0px;
    }

    .m-15-t {
        margin-top: 15px;
    }

    .m-0-b {
        margin-bottom: 0px;
    }

    .m-15-b {
        margin-bottom: 15px;
    }
`;

const GlobalExtended = () => (jsx(Global, { styles: (theme) => css `
            ${globalStyles}

            a, .hyperlink {
                color: inherit;
                cursor: pointer;
                text-decoration: underline;
                text-decoration-color: ${theme.palette.primary[0]};
                text-decoration-thickness: 2px;
                text-underline-offset: 0.3125em;

                &:hover {
                    color: ${theme.colors.textDefault};
                    text-decoration-color: ${theme.colors.textDefault};
                }
            }
        ` }));

const { palette: palette$1, newPalette: newPalette$1 } = globalTheme;
const darkTheme = {
    ...globalTheme,
    name: "dark",
    isDark: true,
    colors: {
        ...globalTheme.colors,
        bg: newPalette$1["black"],
        bgAlt1: newPalette$1["grey-800"],
        bgAlt2: newPalette$1["grey-950"],
        heading: newPalette$1["white"],
        textDefault: newPalette$1["grey-100"],
        textContrast: newPalette$1["black"],
        textInactive: newPalette$1["grey-300"],
        textDim: newPalette$1["grey-300"],
        textDimmer: palette$1.grey[6], //#545454
        borderDefault: newPalette$1["grey-600"],
        borderAlt: newPalette$1["grey-700"],
        iconDefault: newPalette$1["white"],
        iconAlt1: globalTheme.colors.primary,
        iconAlt2: newPalette$1["grey-400"],
        credit: newPalette$1["grey-700"],
        navLink: newPalette$1["grey-400"],
        button: {
            disabledBg: palette$1.grey[2],
        },
        checkbox: {
            text: newPalette$1["grey-200"],
            textDisabled: newPalette$1["grey-500"],
            border: newPalette$1["grey-300"],
            borderDisabled: newPalette$1["grey-600"],
            borderChecked: newPalette$1["grey-300"],
            borderHover: globalTheme.colors.primary,
            error: globalTheme.colors.error,
        },
        modal: {
            bg: palette$1.grey[1],
        },
        tooltip: {
            bg: "#1a1a1a",
        },
        maintenance: {
            bg: "#1a1a1a",
        },
        multiSwitch: {
            bg: palette$1.grey[4],
            text: "black",
            separator: palette$1.grey[0],
        },
        paymentOption: {
            bg: "black",
            text: "white",
            textLoading: "#808080",
            border: palette$1.grey[11],
        },
        textBox: {
            inactive: {
                bg: palette$1.black[1],
                text: palette$1.grey[3],
                border: palette$1.grey[11],
            },
            valid: {
                bg: palette$1.black[0],
                text: palette$1.grey[14],
                border: palette$1.grey[11],
            },
            focused: {
                bg: palette$1.black[0],
                text: palette$1.grey[14],
                border: palette$1.primary[0],
            },
            disabled: {
                bg: palette$1.black[1],
                text: palette$1.grey[3],
                border: palette$1.grey[11],
            },
            error: {
                bg: palette$1.black[1],
                text: palette$1.grey[14],
                border: palette$1.error[3],
            },
        },
        selectBox: {
            fontColor: newPalette$1["grey-200"],
            hoverBg: newPalette$1["grey-900"],
        },
        checkout: {
            text: "#EEEEEE",
        },
        productMatrix: {
            text: "#EEEEEE",
            disabledOverlay: "#222",
            headerBlock: {
                bg: palette$1.grey[0],
                text: "white",
            },
            bodyBg: "#222",
            bodyBorder: "#666",
            footerCta: "#222",
            footerCtaBorder: "#666",
            divider: palette$1.grey[2],
            headers: {
                free: {
                    bg: palette$1.grey[0],
                    text: "white",
                },
                default: {
                    bg: palette$1.primary[0],
                    text: "white",
                },
                promo: {
                    bg: "white",
                    text: palette$1.primary[0],
                },
            },
        },
        tabs: {
            defaultText: "#999",
            activeText: "#FFFFFF",
            hoverText: "#FFFFFF",
            borderBottom: "#333",
        },
    },
};

const DarkThemeProvider = ({ children }) => (jsxs(ThemeProvider, { theme: darkTheme, children: [jsx(GlobalExtended, {}), children] }));

const { palette, newPalette } = globalTheme;
const lightTheme = {
    ...globalTheme,
    name: "light",
    colors: {
        ...globalTheme.colors,
        bg: newPalette["white"],
        bgAlt1: newPalette["grey-100"],
        bgAlt2: newPalette["grey-50"],
        heading: newPalette["black"],
        textDefault: newPalette["grey-800"],
        textContrast: newPalette["white"],
        textInactive: newPalette["grey-600"],
        textDim: palette.grey[2], //#494949
        textDimmer: newPalette["grey-300"],
        borderDefault: newPalette["grey-400"],
        borderAlt: newPalette["grey-300"],
        iconDefault: newPalette["black"],
        iconAlt1: globalTheme.colors.primary,
        iconAlt2: newPalette["grey-600"],
        credit: newPalette["grey-700"],
        navLink: newPalette["grey-600"],
        button: {
            disabledBg: palette.grey[7],
        },
        checkbox: {
            text: newPalette["grey-800"],
            textDisabled: newPalette["grey-400"],
            border: newPalette["grey-400"],
            borderDisabled: newPalette["grey-300"],
            borderChecked: newPalette["grey-400"],
            borderHover: globalTheme.colors.primary,
            error: globalTheme.colors.error,
        },
        modal: {
            bg: "white",
        },
        tooltip: {
            bg: "white",
        },
        maintenance: {
            bg: "white",
        },
        multiSwitch: {
            bg: palette.grey[4],
            text: palette.grey[0],
            separator: palette.grey[3],
        },
        textBox: {
            inactive: {
                bg: palette.grey[13],
                text: palette.grey[11],
                border: palette.grey[3],
            },
            valid: {
                bg: palette.grey[13],
                text: palette.grey[0],
                border: palette.grey[3],
            },
            focused: {
                bg: "white",
                text: palette.grey[0],
                border: palette.primary[0],
            },
            disabled: {
                bg: palette.grey[13],
                text: palette.grey[3],
                border: palette.grey[3],
            },
            error: {
                bg: palette.grey[13],
                text: palette.grey[0],
                border: palette.error[3],
            },
        },
        selectBox: {
            fontColor: newPalette["grey-800"],
            hoverBg: newPalette["grey-100"],
        },
        paymentOption: {
            bg: "white",
            text: "black",
            textLoading: "#999999",
            border: palette.grey[3],
        },
        checkout: {
            text: "#000",
        },
        productMatrix: {
            text: "black",
            disabledOverlay: "white",
            headerBlock: {
                bg: palette.primary[3],
                bg2: palette.grey[8],
                text: palette.grey[6],
            },
            bodyBg: "white",
            bodyBorder: "#aaa",
            footerCta: palette.grey[5],
            footerCtaBorder: palette.grey[5], //added same color so it doesn't show unless you'd need it to
            divider: palette.grey[4],
            border: palette.grey[4],
            headers: {
                free: {
                    bg: palette.grey[4],
                    text: "black",
                },
                default: {
                    bg: palette.primary[0],
                    text: "white",
                },
                promo: {
                    bg: palette.grey[0],
                    text: "white",
                },
            },
        },
        tabs: {
            defaultText: "#000",
            activeText: "#666",
            hoverText: "#000",
            borderBottom: "#CCC",
        },
    },
};

const LightThemeProvider = ({ children }) => (jsxs(ThemeProvider, { theme: lightTheme, children: [jsx(GlobalExtended, {}), children] }));

export { DarkThemeProvider, LightThemeProvider, darkTheme, lightTheme };
